const KILOBYTES_PER_MEGABYTE = 1024

/** A size given in kilobytes as megabytes when it is a whole number of them, otherwise as kilobytes. */
export const formatFileSize = (kilobytes: number): string =>
  kilobytes >= KILOBYTES_PER_MEGABYTE && kilobytes % KILOBYTES_PER_MEGABYTE === 0
    ? `${kilobytes / KILOBYTES_PER_MEGABYTE} MB`
    : `${kilobytes} KB`
